var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13V7M9.5 7L6.5 9M9.5 7L12.5 9M0.5 3V13.8C0.5 14.9201 0.5 15.4798 0.717987 15.9076C0.909734 16.2839 1.21547 16.5905 1.5918 16.7822C2.0192 17 2.57899 17 3.69691 17H15.3031C16.421 17 16.98 17 17.4074 16.7822C17.7837 16.5905 18.0905 16.2841 18.2822 15.9078C18.5002 15.48 18.5002 14.9199 18.5002 13.7998L18.5002 6.19978C18.5002 5.07967 18.5002 4.51962 18.2822 4.0918C18.0905 3.71547 17.7839 3.40973 17.4076 3.21799C16.9798 3 16.4201 3 15.3 3H9.5M0.5 3H9.5M0.5 3C0.5 1.89543 1.39543 1 2.5 1H6.17452C6.6637 1 6.90886 1 7.13904 1.05526C7.34311 1.10425 7.53785 1.18526 7.7168 1.29492C7.91857 1.41857 8.09181 1.59182 8.4375 1.9375L9.5 3",
    stroke: "#E4D7CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c11a1a3c4b41980fbbcfc75dbdd0f940.svg";
export { ForwardRef as ReactComponent };